import {useParams} from 'react-router-dom';
import {
    Alert,
    Grid,
} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {DetailPageNavigation} from '../navigation/DetailPageNavigation.tsx';
import {ObservationsPanel} from '../components/ObservationsPanel.tsx';
import {useSyntheticUser} from '../hooks/useSyntheticUser.ts';

// FNP-861: READ-ONLY detail view. No edit mode, no wake trigger, no retire action.
export const DetailPage = () => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const {
        record,
        loading,
        isError,
        notFound,
    } = useSyntheticUser(id);

    if (loading) {
        return <PlatformLoader message='Loading synthetic user...Please wait'/>;
    }

    if (isError || notFound || !record) {
        return (
            <Alert color='red' title='Synthetic user not found'>
                No synthetic user found for id <code>{id}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={record.email}
            pageNavigation={<DetailPageNavigation component={record}/>}
        >
            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 4
                }}>
                    <Profile record={record}/>
                </Grid.Col>
                <Grid.Col span={{
                    base: 12,
                    lg: 8
                }}>
                    {/* What this user actually did — the GSI-backed link between the
                        roster and the observations (FNP-861). */}
                    <ObservationsPanel syntheticUserId={record.id}/>
                </Grid.Col>
            </Grid>
        </FormPageLayout>
    );
};
